export const PERCENTILE_ITEMS_PANEL_WIDTH = 400;
